// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1fObg","detailsBorder":"styles_detailsBorder__2oaR_"};